import React from 'react';
import { Navigate } from 'react-router-dom';
import { useInstructorAuth } from '../../context/InstructorAuthContext';

const InstructorProtectedRoute = ({ children }) => {
  const { instructor, loading } = useInstructorAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', background: '#0f1923', color: '#fff', fontSize: '1.1rem'
      }}>
        Loading...
      </div>
    );
  }

  if (!instructor) {
    return <Navigate to="/instructor-login" replace />;
  }

  return children;
};

export default InstructorProtectedRoute;
